import { Box, TextField, Typography } from '@mui/material';
import React from 'react';
import { Controller, useForm } from 'react-hook-form';

import ControlledCheckbox from '~components/Form/ControlledCheckbox';
import { ParameterPlayMessage } from '~pages/SipConfiguration/domain';

import { ContactFlowNodeProps } from '..';
import BaseNode from '../BaseNode';

export default function PlayMessageNode(props: ContactFlowNodeProps) {
  const form = useForm<ParameterPlayMessage>({
    defaultValues: props.data.parameter.playMessage,
  });
  return (
    <BaseNode
      {...props}
      title='Play Message'
      parameterForm={form}
      renderParameterForm={(playMessage) => (
        <>
          <Typography>Message key: {playMessage?.messageKey || '--'}</Typography>
          <Typography>Cancel on DTMF: {playMessage?.cancelOnDTMF ? 'Yes' : 'No'}</Typography>
          <Typography>Dont clear DTMF: {playMessage?.dontClearDTMF ? 'Yes' : 'No'}</Typography>
        </>
      )}
      transformParameter={(playMessage) => ({ playMessage })}
      renderEditParameter={({ control }) => (
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            gap: 1,
          }}>
          <Controller
            control={control}
            name='messageKey'
            defaultValue=''
            render={({ field }) => <TextField {...field} fullWidth label='Message Key' />}
          />
          <ControlledCheckbox control={control} name='cancelOnDTMF' label='Cancel on DTMF' defaultValue={false} />
          <ControlledCheckbox control={control} name='dontClearDTMF' label='Dont clear DTMF' defaultValue={false} />
        </Box>
      )}
    />
  );
}
